<template>
    <div class="page">
        <div class="intro">
            <h1 class="white">Brittany Foster</h1>
            <h2>UX Designer | Phoenix, AZ</h2>
            <p>PHX based UX Designer with a passion for creative problem-solving, visual design, and crafting intuitive user experiences.</p>
        </div>
        <div class="caseBox">
            <h3>Case Studies</h3>
            <div class="cards">
                <Card image="evolveshop_logo_glow.png" title="Organize, Digitize & Visualize Prefab" link="shop"></Card>
                <Card image="evolve_globe_glow.png" title="Brand &amp; Company Identity" link="brand"></Card>
            </div>
        </div>
    </div>
</template>

<script>
    import Card from '../components/Card.vue'

    export default {
        name: 'Home',
        components: {
            Card
        },
    }
</script>

<style scoped>
    .intro{
        text-align: center;
        font-weight: 700;
        margin: 0px auto;
        margin-top: 50px;
        padding: 30px 20px 100px 20px;
        max-width: 700px;
        width: 100%;
        box-sizing: border-box;
    }

    .intro p{
        font-size: 1.2rem;
    }

    h1{
        font-size: 3em;
        font-weight: 500;
    }

    .white{
        color: #fff;
       text-shadow:
  0 0 3px rgba(255, 255, 255, 0.75),
  0 0 6px rgba(255, 255, 255, 0.4),
  0 0 10px rgba(255, 255, 255, 0.1);
    }

    h2{
        font-size: 2em;
        margin-top: 10px;
        font-weight: 400;
    }

    h3{
        font-size: 2em;
        margin-top: 10px;
        font-weight: 600;
        color: #fff;
        text-transform: uppercase;
    }

    h4{
        font-size: 1.7em;
        margin-top: 50px;
    }

    p{
        margin-top: 30px;
        font-weight: 300;
    }

    .caseBox{
        background-color: #0E0C0A;
        border-radius: 12px;
        max-width: 1400px;
box-shadow:
  0 0 8px rgba(197, 185, 166, 0.35),
  0 4px 16px rgba(197, 185, 166, 0.25);
margin: 40px auto;
padding: 40px;
    }

    .cards{
        margin: 50px 30px;
    }

    .slides{
        margin: 30px auto;
        max-width: 1000px;
        line-height: 30px;
        text-align: left;
        transition: 0.5s;
        padding: 0px 50px;
        box-sizing: border-box;
    }

    .slide-text{
        transition: 0.5s;
        height: auto;
        min-height: 250px;
        position:relative;
        animation:animateleft 0.4s;
    }

    #linkedin{
        padding: 30px;
        box-sizing: border-box;
    }

    #linkedin:hover{
        cursor: pointer;
    }

    /* Styles for the carousel container */
    .slides {
        display: flex; /* Flex layout for horizontal alignment of slides */
        flex-direction: column; /* Display slides vertically */
    }

    /* Styles for individual slides */
    .slide-text {
        display: none; /* Initially hide all slides */
    }

    /* Style for the active slide */
    .slide-text.active {
        display: block; /* Show the active slide */
    }

    @keyframes animateleft{from{left:-300px;opacity:0} to{left:0;opacity:1}}

    @media only screen and (max-width: 700px){
            h1{
                font-size: 2em;
            }

            h2{
                font-size: 1.3em;
                margin-top: 5px;
            }

            .slide-text{
                height: auto;
                min-height: 350px;
            }

            .caseBox{
                margin-left: 20px;
                margin-right: 20px;
            }
    }
</style>
